<template>
  <!-- <v-autocomplete
    dense
    class="autoCompleted"
    outlined
    v-bind="$attrs"
    :items="list"
    v-on="$listeners"
    :search-input.sync="search"
    :value="value"
    @input="x => $emit('input', x)"
    :disabled="disabled"
    no-filter
    :prepend-inner-icon="icon"
  >
    <template v-if="hasItemsSlot" v-slot:item="x">
      <slot :item="x.item" name="items"></slot>
    </template>
  </v-autocomplete> -->
  <v-combobox
    dense
    :value="value"
    @input="x => $emit('input', x)"
    :items="list"
    small-chips
    deletable-chips
    clearable
    multiple
    outlined
    hide-details="auto"
    v-bind="$attrs"
    v-on="$listeners"
    :prepend-inner-icon="icon"
    :search-input.sync="search"
    :class="{ 'small-input': small }"
  >
    <!-- <template v-slot:no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            No results matching "<strong>{{ search }}</strong
            >". Press <kbd>enter</kbd> to create a new one
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template> -->
    <template v-for="(_, name) in $scopedSlots" v-slot:[name]="props">
      <slot :name="name" v-bind="props" />
    </template>
  </v-combobox>
</template>

<script>
import { crudList } from '@/api/crud';
import api from '@/api';
import { debounce } from 'lodash';

export default {
  name: 'masterAutocomplete',
  props: {
    path: {},
    value: {},
    params: {},
    icon: {
      type: String,
      default: 'mdi-magnify',
    },
    small: {
      Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      search: null,
      debounceToGetData: debounce(this.reload, 500),
    };
  },
  methods: {
    async reload() {
      const searchResult = await crudList(api, this.path, { search: this.search, ...this.params });
      this.list = searchResult.docs || searchResult;
    },
  },
  watch: {
    search: {
      immediate: true,
      handler(v) {
        this.debounceToGetData();
      },
    },
    params: {
      handler(v) {
        this.debounceToGetData();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.autoCompleted .v-icon {
  transform: rotate(0deg) !important;
}
</style>
